import React, { useContext, useState, useEffect, useRef } from 'react';
import HeaderForm from './headerformnurse';
import DownloadIcon from '@mui/icons-material/Download';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckIcon from '@mui/icons-material/Check';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import FilterListIcon from '@mui/icons-material/FilterList';

import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';

import {
  Navigate,
  useNavigate,
  Link
} from "react-router-dom";

import { useDispatch } from "react-redux";
import { AppContext } from '../context';

import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { toast } from "react-toastify";
import  secureLocalStorage  from  "react-secure-storage";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#676666',
    color: '#ffffff',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}


function Application() {

  const [openLog, setOpenLog] = React.useState(false);
  const handleCloselogss = () => setOpenLog(false);
  const handleCloselog = () => setOpenLog(true);

  const [opencheckLog, setOpenCheckLog] = React.useState(false);
  const handlecheckCloses = () => setOpenCheckLog(false);
  const handlecheckClose = () => setOpenCheckLog(true);
  const [manageapplicationList, setManagApplicationsList] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [loadernew, setLoaderNew] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [loaderId, setLoaderId] = useState('');
  const [searchType, setSearchType] = useState('employeeid');
  const [pageLoader, setPageLoader] = useState(false);
  const [loginval, setloginval] = useState(0);
  const { storage } = useContext(AppContext);
  const [reason, setReason] = React.useState('');
  const [actionRow, setActionRow] = React.useState(null);
  const [submitting, setSubmitting] = React.useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [uploadErr, setUploadErr] = useState('');
  const [uploadSuccess, setUploadSuccess] = useState('');
  const [submitErr, setSubmitErr] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState('');
  const [openIsUploaded, setOpenIsUploaded] = React.useState(false);
  const [isUploadedProcessing, setIsUploadedProcessing] = React.useState(false);
  const [isUploadedSuccess, setIsUploadedSuccess] = React.useState(null);
  const [isUploadedErr, setIsUploadedErr] = React.useState(null);
  const [searchPlaceholder, setSearchPlaceholder] = useState('Student ID or Name');
  const [searchBy, setSearchBy] = useState('student_id');
  const [searchValue, setSearchValue] = useState('');
  const [checkUnderstand, setCheckUnderstand] = useState(false);
  const [ipuser, setIpuser] = useState(null);


  const [allDepartment, setAllDepartment] = useState([]);
  const Axios = axios.create({
    baseURL: storage[0].backEndUrl
    // baseURL: process.env.REACT_APP_ENV_URL
  });
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [Viewuser, setuser] = useState(null);

  const [rejectLog, setRejectLog] = React.useState(false);
  const handlereject = () => {
    setRejectLog(true);
    setApproveLog(false);

  }
  const [openformsLog, setOpenformsLog] = React.useState(false);
  const handleFormsClose = () => setOpenformsLog(false);
  const handleFormsOpen = () => handleFormsOpen(true);
  const [formsdata, setformsdata] = useState(null);
  const handleFormStatusCheck = (useridnew) => {
    if (useridnew.pending_parent_form != 0) {
      setformsdata(useridnew);
      setOpenformsLog(true);
      //setRejectLog(false);
      //setApproveLog(false);
      setReason('');
    } else {
      setActionRow(useridnew);
      setOpenCheckLog(true);
      setOpenformsLog(false);
      //setRejectLog(false);
      //setApproveLog(false);
      setReason('');
    }

  }


  const handleFormStatus = (item) => {
    setActionRow(item);
    setOpenCheckLog(true);
    //setRejectLog(false);
    setOpenformsLog(false);
    //setApproveLog(false);
    setReason('');
  }

  const [alldelete, setAlldelete] = useState(null);
  const [physicianDeleteId, setPhysicianDeleteId] = useState(null);
  const [openLogDelele, setOpenLogDelele] = React.useState(false);
  const handleDeleleClose = () => setOpenLogDelele(false);
  const handleDeleleOpen = () => setOpenLogDelele(true);
  const handleOpenDelete = (userid, id) => {
    setPhysicianDeleteId(id);
    setAlldelete(userid);
    setOpenLogDelele(true);
  }

  const handlesubmit = () => {
    if (submitting) return;
    setSubmitErr('');
    if (reason == '') {
      setSubmitErr('Please enter reason.');
      return false;
    }
    setSubmitting(true);
    Axios.post(`/application/update-status/${actionRow.id}`, {
      status: rejectLog ? 'Rejected' : 'Approved',
      reason: reason,
      nurseid: secureLocalStorage.getItem('nurseid')
    })
      .then(res => {
        if (res.data.status) {
          setSubmitSuccess(res.data.message);
          setTimeout(() => {
            setRejectLog(false);
            setApproveLog(false);
            setReason('');
            setOpenCheckLog(false);
            setSubmitSuccess('');
          }, 2000);
          loadApplications();
        } else {
          setSubmitErr(res.data.message);
          setTimeout(() => {
            setRejectLog(false);
            setApproveLog(false);
            setReason('');
            setOpenCheckLog(false);
            setSubmitSuccess('');
          }, 2000);
          loadApplications();
        }
        setSubmitting(false);
      })
  }

  const [approveLog, setApproveLog] = React.useState(false);
  const handleapprove = () => {
    setApproveLog(true);
    setRejectLog(false);

  }


  useEffect(() => {
    axios.get("https://ipinfo.io/json")
      .then(res => {
        setIpuser(res.data.ip);
      }).catch(err => {
        
      })

  }, []);

  useEffect(() => {
    loadApplications();
  }, [pageNo, perPage, searchBy, searchValue]);

  const loadApplications = () => {
    
    setFirstLoading(true);
    var usernew = JSON.parse(secureLocalStorage.getItem('nursedata'));
   
    if (usernew==null || usernew==undefined) {
      navigate(`/stafflogin`);
    }else{
      setuser(usernew);
      Axios.post(`/application_list`, { location: usernew.location, "pageNo": pageNo, "perPage": perPage, search_by: searchBy, search: searchValue })
        .then(res => {
          setManagApplicationsList(res.data.data);
          setTotalCount(res.data.pagination.totalCount);
          setTotalPage(res.data.pagination.totalPage);
          setFirstLoading(false);
        });
    }
    

  }

  const handleReasonChange = (e) => {
    const { name, value } = e.target;
    setReason(value);
  }

  const handleDownloadFile = (id) => {
    let applItem = getApplicationRow(id);
    Axios.get(`/downloadforms/${id}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, `parent_consent_forms_${applItem.stuid}.zip`);
      })
  }

  const handlePhysicianDownloadFile = (id) => {
    let applItem = getApplicationRow(id);
    Axios.get(`/application/download-physician-form/${id}`, {
      responseType: 'blob',
    })
      .then(res => {
        downloadBlob(res.data, `physician_forms_${applItem.stuid}.zip`);
      })
  }

  const downloadBlob = (data, filename) => {
    // Create a blob from the res data
    const blob = new Blob([data], { type: data.type });

    // Create a link element
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    window.URL.revokeObjectURL(link.href);
    document.body.removeChild(link);

  }

  const handleDownload = (fileName) => {
    const link = document.createElement('a');
    link.href = storage[0].imageEndUrl + fileName;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleUploadDialog = (item) => {
    setActionRow(item);
    setOpenLog(true);
  }

  const getCurrentPendingPhysicianForms = () => {
    return 2 - actionRow.physician_document_details.length
  }

  const handleFileChange = (event) => {
    setUploadErr('');
    const files = Array.from(event.target.files);
    const pdfFiles = files.filter(file => file.type === 'application/pdf');
    if (selectedFile.length + pdfFiles.length > getCurrentPendingPhysicianForms()) {
      setUploadErr(`You can only upload a maximum of ${getCurrentPendingPhysicianForms()} file(s).`);
      return;
    }
    setSelectedFile([...selectedFile, ...pdfFiles]);
  };

  const handleFileRemove = (index) => {
    const newFiles = [...selectedFile];
    newFiles.splice(index, 1);
    setSelectedFile(newFiles);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setUploadErr('');
    const files = Array.from(event.dataTransfer.files);
    const pdfFiles = files.filter(file => file.type === 'application/pdf');
    if (selectedFile.length + pdfFiles.length > getCurrentPendingPhysicianForms()) {
      setUploadErr(`You can only upload a maximum of ${getCurrentPendingPhysicianForms()} file(s).`);
      return;
    }
    setSelectedFile([...selectedFile, ...pdfFiles]);
  };

  const handleUpload = () => {
    if (uploading) return;
    setUploadErr('');

    // if (selectedFile.length < getCurrentPendingPhysicianForms()) {
    //   setUploadErr('Please select physician file to upload.');
    //   return;
    // }
    if (selectedFile.length > getCurrentPendingPhysicianForms()) {
      setUploadErr(`You can only upload a maximum of ${getCurrentPendingPhysicianForms()} file(s).`);
      return;
    }

    setUploading(true);
    const formData = new FormData();
    selectedFile.forEach((file, i) => {
      formData.append(`files[${i}]`, file);
    });
    formData.append('ip_address', ipuser);

    Axios.post(`/application/upload-physician-form/${actionRow.id}`, formData)
      .then(res => {
        if (res.data.status) {
          setUploadSuccess(res.data.message);
          setTimeout(() => {
            setSelectedFile([]);
            setOpenLog(false);
            setUploadSuccess('');
          }, 2000);
          loadApplications();
        } else {
          setUploadErr(res.data.message);
        }
        setUploading(false);
      })
  }

  const getApplicationRow = (id) => {
    return manageapplicationList.find(item => item.id == id);
  }

  const truncateString = (str, num) => {
    if (str.length > num) {
      return str.slice(0, num) + '...';
    } else {
      return str;
    }
  }

  const perPageChange = (e) => {
    setPerPage(e.target.value);
    setPageNo(1);
   
  };

  const changePage = (page) => {
    var usernew = JSON.parse(secureLocalStorage.getItem('nursedata'));
    if (page < 1) page = 1;
    if (page > totalPage) page = totalPage;
    setFirstLoading(true);
    setPageNo(page);


 
  }

  const handlePhycianDelte = () => {
    if (uploading) return;
    setUploadErr('');

    setUploading(true);

    Axios.post(`/physician_file_delete/`, { id: physicianDeleteId, consent_form_id: alldelete })
      .then(res => {
        if (res.data.status) {
          setUploadSuccess('Physician Form Deleted Successfully');
          loadApplications();
          setTimeout(() => {
            setPhysicianDeleteId(null);
            setAlldelete(null);
            setOpenLogDelele(false);
            setUploadSuccess('');
          }, 2000);

        } else {
          setUploadErr('Error');
        }
        setUploading(false);
      })
  }



  const handleIsUploaded = (e, useridnew) => {
    e.preventDefault();

  
    setformsdata(useridnew);
    setOpenIsUploaded(true);
    setCheckUnderstand(false);
  }

  const isUploadedClose = () => {
    setOpenIsUploaded(false);
  }

  const handleIsUploadConfirm = () => {
    if (isUploadedProcessing) return;
    setIsUploadedErr('');
    setIsUploadedProcessing(true);
    Axios.post(`/application/update-uploaded/${formsdata.id}`)
      .then(res => {
        if (res.data.status) {
          setIsUploadedSuccess(res.data.message);
          loadApplications();
          setTimeout(() => {
            isUploadedClose();
            setIsUploadedSuccess('');
          }, 2000);

        } else {
          setIsUploadedErr(res.data.message);
        }
        setIsUploadedProcessing(false);
      })
  }

  const handleSearchInput = (e) => {
    setSearchValue(e.target.value);
    setPageNo(1);
  }

  const handleColumnClick = (type) => {
    let placeholder = '';
    switch (type) {
      case 'location':
        placeholder = 'Location';
        break;
      case 'student_id':
        placeholder = 'Student ID or Name';
        break;
      case 'student_name':
        placeholder = 'Student Name';
        break;
      case 'grade':
        placeholder = 'Grade';
        break;
      default:
        placeholder = 'Location';
        break;
    }
    setSearchPlaceholder(placeholder);
    setSearchBy(type);
    setPageNo(1);
  }

  const handleChangeUnderstand = (e) => {
    setCheckUnderstand(e.target.checked);
  }

  const handleApprovedProcess = (e, userd) => {
    e.preventDefault();

    setRejectLog(false);
    setApproveLog(true);

    handleFormStatusCheck(userd);

  }

  const handleDeclinedProcess = (e, userd) => {
    e.preventDefault();

    setRejectLog(true);
    setApproveLog(false);

    handleFormStatusCheck(userd);
  }


  return (
    <>
      <HeaderForm />
      <div className='regis-main-sec forms-main-sec'>
        <div className='container-fluid'>

          <div className='row'>
            <div className='col-md-12'>
              <div className='regis-head forms-heading-sec'>
                <h2>Application Listing</h2>
                 <div className='check-higt-app'>

                
                <Link to="/applicationstatus"> <p className='stts-sec  go-frm-cols go-new-add '>CHECK APPLICATION STATUS HERE</p>

                  <div class="scroll-prompt" scroll-prompt="" ng-show="showPrompt" style={{ opacity: '1' }}>
                    <div class="scroll-prompt-arrow-container new-go-spp">
                      <div class="scroll-prompt-arrow"><div></div></div>
                      <div class="scroll-prompt-arrow new-scroll"><div></div></div>
                    </div>
                  </div>
                </Link>
                </div>
                {/*<Link to="/applications/forms-uploaded-list"> <p className='stts-sec  go-frm-cols go-new-add '>ALL FORMS UPLOADED LIST</p>

                <div class="scroll-prompt" scroll-prompt="" ng-show="showPrompt" style={{ opacity: '1' }}>
                  <div class="scroll-prompt-arrow-container new-go-spp">
                    <div class="scroll-prompt-arrow"><div></div></div>
                    <div class="scroll-prompt-arrow new-scroll"><div></div></div>
                  </div>
                </div>
              </Link>*/}

              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <div className='club-sec application-sec'>
                <div className='container-fluid '>

                  <div className='club-inner-secss form-table-sec table-section-route table-form appl-sec'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='indicate-secss'>
                          <p className='style-new'><span className='square-sec'></span>All Forms Uploaded</p>
                          <p><span className='square-sec-red'></span>Partial Forms Uploaded</p>
                        </div>

                      </div>
                      <div className="col-sm-3"  >
                        <div className="sorting-e-form " style={{ marginTop: '-50px' }}>
                          <label style={{ width: '100%' }}><span style={{ marginRight: '10px', fontSize: '14px' }}>Show entries</span>
                            <select className='selee-sort' onChange={perPageChange} value={perPage}>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                            </select>

                          </label>
                        </div>
                      </div>
                      <div className="col-md-6 margin-ns-pad">

                        {manageapplicationList.length > 0 ?
                          <p className="total-user right-user tot-app" style={{ marginTop: '-55px' }}>Total Applications {totalCount}</p>
                          : null}

                        <div className='filtr-sec'>
                          <div className='select-sec-newss' >
                            <select>
                              <option>Liberty High School</option>
                              <option>Liberty High School</option>
                              <option>Liberty High School</option>
                            </select>
                          </div>

                          <div className='text-fld-sec appl_list'>
                            <input type="text" placeholder={searchPlaceholder} onChange={handleSearchInput} value={searchValue} className='inpt-sec' />
                            <span className='search-sec'><SearchIcon /></span>
                          </div>
                        </div>


                      </div>
                      {/* <div className='col-md-3'>

                      </div> */}
                    </div>
                    <div className='row'>
                      <div className='col-md-12'>
                        <table className="table table-bordered">
                          <thead className="thead-light thead-travel thead-form">
                            <tr>
                              <th className='std-id-width app-td' onClick={() => handleColumnClick('student_id')} role='button'>Student ID <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                              <th className='loc-width app-loc' onClick={() => handleColumnClick('location')} role='button'>Location <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                              <th className='std-name-width app-std-nme' onClick={() => handleColumnClick('student_name')} role='button'>Student Name <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                              <th className='grade-width app-grd' onClick={() => handleColumnClick('grade')} role='button'>Grade <span className='fitr-sec-nw'><FilterListIcon /></span></th>
                              <th className='date-width app-part-frm'>Parent Consent Form</th>
                              <th className='date-width app-phy-frm'>Physician Form</th>
                              <th className='stts-width app-up'>Upload</th>
                              <th className='stts-width app-act'>Action</th>
                              {/* <th className='action-width'>Action</th> */}
                            </tr>
                          </thead>
                          <tbody className='tbody-light tbody-form'>
                            {
                              firstLoading ? <tr ><td colSpan={8}><div className="spinner-border" role="status" style={{ width: "1rem", height: "1rem", marginLeft: "6px" }}></div></td></tr> : <>
                                {manageapplicationList.length > 0 ?

                                  manageapplicationList.map((userd, index) =>
                                    <tr key={index}>
                                      <td className='std-id'>{userd.stuid}</td>
                                      <td>
                                        
                                        {userd.school_name}
                                        
                                        </td>
                                      <td>{userd.student_name} {userd.last_name}</td>
                                      <td>
                                          
                                        {userd.stu_grade}
                                       
                                        
                                        </td>
                                      <td><p className='form-comp'>
                                        {userd.document_details.length > 0 && userd.document_details.length}

                                        <span className={` ${(userd.pending_parent_form != 0) && 'red-down'} ${(userd.pending_parent_form == 0) && 'blue-down'}`}>
                                          <a title="Download"><DownloadIcon onClick={() => handleDownloadFile(userd.id)} /></a></span></p>
                                        {
                                          userd.pending_parent_form != 0 ? <p className='form-pend'>{userd.pending_parent_form} Form Pending</p> : null
                                        }
                                      </td>
                                      <td>

                                        {
                                          userd.physician_document_details.length < 2 ?
                                            <div className='upload-secs'>
                                              <CloudUploadIcon onClick={() => handleUploadDialog(userd)} />{/*<p className='form-pend'>{(2 - userd.physician_document_details.length)} Form Pending</p>*/}
                                            </div>
                                            :
                                            null
                                        }
                                        {
                                          userd.physician_document_details.length ?
                                            <div>
                                              <ul className='list-group'>
                                                {
                                                  userd.physician_document_details.map((item, index2) => (
                                                    <li className='list-group-item psycn-form-link phy-dd-lnk' key={index2}>
                                                      <span className="blue-down">
                                                        <a title="Download" ><DownloadIcon className='download_icon' onClick={() => handlePhysicianDownloadFile(userd.id)} />
                                                        </a></span> {truncateString(item.document, 20)}
                                                      <CloseIcon title="delete" className='delete_icon delt-sss' onClick={() => handleOpenDelete(userd, item.id)} />
                                                    </li>
                                                  ))
                                                }

                                              </ul>
                                            </div> : null
                                        }
                                      </td>

                                      {/*<td className='std-id' onClick={() => handleFormStatusCheck(userd)}><CheckIcon /></td>*/}
                                      <td className='std-id chck-tbl-sec'>
                                        <div className='d-flex justify-content-center'>
                                          <FormGroup className='radio-sec'>
                                            <FormControlLabel
                                              label=""
                                              className='upload_checkbox'
                                              control={<Checkbox />}
                                              checked={userd.is_uploaded ? true : false} onChange={(e) => handleIsUploaded(e, userd)} />
                                          </FormGroup>
                                        </div>
                                      </td>
                                      <td className='std-id chck-tbl-sec'>
                                        <div className='d-flex justify-content-center'>
                                          <FormGroup className='radio-sec'>
                                            <HtmlTooltip
                                              title={
                                                <React.Fragment>
                                                  <Typography color="inherit" >Approve</Typography>
                                                </React.Fragment>
                                              }
                                            >
                                              <FormControlLabel
                                                label=""
                                                className='approved_checkbox'
                                                control={<Checkbox />}
                                                checked={false} onChange={(e) => handleApprovedProcess(e, userd)} />
                                            </HtmlTooltip>

                                            <HtmlTooltip
                                              title={
                                                <React.Fragment>
                                                  <Typography color="inherit" >Decline</Typography>
                                                </React.Fragment>
                                              }
                                            >
                                              <FormControlLabel
                                                label=""
                                                className='declined_checkbox'
                                                control={<Checkbox />}
                                                checked={false} onChange={(e) => handleDeclinedProcess(e, userd)} />
                                            </HtmlTooltip>
                                          </FormGroup>
                                        </div>
                                      </td>
                                      {/* <td className='action-sec'><Link to="/applicationdetails"><VisibilityIcon /></Link></td> */}
                                    </tr>
                                  )

                                  : <tr><td colSpan={8}>No Data Found</td></tr>}
                              </>
                            }

                          </tbody>
                        </table>
                        {/* pagination code start  */}

                        {totalPage > 1 ? <>
                          <div className="pagination-sec" style={{ boxShadow: '#ff98001a 0px 7px 16px 0px', width: "auto", float: "right", border: "1px solid #FF9800", marginTop: "2px", marginRight: "5px", height: "40px" }}>
                            <div style={{ float: "left", padding: "0px 0px", color: "#0B5CAB", fontSize: "14px", width: '100%', position: 'relative', display: 'inline-flex' }}>
                              <div className="" style={{ backgroundColor: '#FF9800', color: '#ffffff' }}>
                                <p style={{ marginBottom: '0px', padding: '9px 10px' }}>Page {pageNo} of {totalPage}</p>
                              </div>
                              <div className="pagin-sec">
                                <i className="fa-solid fa-angle-left" style={{ float: "left", marginTop: "10px", marginLeft: "10px", cursor: "pointer", fontSize: '18px', color: '#727272' }} onClick={(e) => changePage(pageNo - 1)}></i>
                                <span className="go-sec" style={{ float: "left", fontSize: "15px", marginTop: "10px", marginLeft: "10px", marginRight: '10px', color: "#626262" }}>Go to </span>
                                <input type="number"
                                  value={pageNo} onChange={(e) => {
                                    !isNaN(parseInt(e.target.value)) && parseInt(e.target.value) > 0 ? changePage(parseInt(e.target.value)) : changePage(1)
                                  }}
                                  style={{ paddingTop: '4px', color: "rgb(0, 23, 55)", margin: "8px 6px 0px 4px", fontSize: "14px", width: "34px", height: '34px', float: "left", height: "22px", textAlign: "center", border: "1px solid #727272", borderRadius: "3px", outline: "none" }} />

                                <i className="fa-solid fa-angle-right" style={{ float: "left", marginTop: "10px", marginRight: '6px', marginLeft: "5px", cursor: "pointer", fontSize: '20px', color: '#727272' }} onClick={(e) => changePage(pageNo + 1)}></i>
                              </div>
                            </div>

                          </div>
                        </> : ''
                        }

                        {/* pagination code end */}


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* modal section start */}

      <BootstrapDialog
        onClose={handleCloselog}
        aria-labelledby="customized-dialog-title"
        open={openLog} className="route-view copy-view logout-view login-modal app-modal">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselogss}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec' style={{ paddingTop: '0px' }}>


              <h2 className='uplod-secddd new-upld'>Please upload physician form</h2>




              <div
                className="formbold-file-input"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <input
                  type="file"
                  name="file"
                  id="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  accept="application/pdf"
                  multiple
                />
                <label htmlFor="file">
                  <div className="upload-label-sec">
                    <a> <CloudUploadIcon /></a>
                    <div className="bros-sec">
                      <p className="formbold-drop-file">Upload File </p>
                      <p className="formbold-drop-file">Drag and Drop File </p>
                    </div>
                  </div>
                </label>
              </div>

              <p className='only-pdf'>Only PDF files Supported</p>
              {selectedFile.length ? (
                <div>
                  <ul className='list-group'>
                    {
                      selectedFile.map((file, index) => (
                        <li key={index} className='list-group-item list-app'>
                          {truncateString(file.name, 35)}
                          <DeleteIcon onClick={() => handleFileRemove(index)} />
                        </li>
                      ))
                    }
                  </ul>
                </div>
              ) : null}

              <div className='button-sec-app'>
                <button className="btn btn-login btn-submit bt-forms" style={{ marginTop: '0px' }} type='button' onClick={handleUpload}>
                  {
                    uploading ?
                      <>
                        Submit <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </>
                      :
                      <>
                        Submit
                      </>
                  }
                </button>
              </div>
              {
                uploadSuccess ?
                  <div className="success-msg success-login success-new-msg">
                    <p className="success-msg success-login" >{uploadSuccess}</p>
                  </div>
                  : null
              }
              {
                uploadErr ?
                  <div className="error-msg error-login" >
                    <p className="error-msg error-login">{uploadErr}</p>
                  </div>
                  : null
              }
            </div>



          </Typography>
        </DialogContent>
      </BootstrapDialog>
      {/* modal section end */}


      {/* modal section for status start */}

      <BootstrapDialog
        onClose={handlecheckClose}
        aria-labelledby="customized-dialog-title"
        open={opencheckLog} className="route-view copy-view logout-view login-modal app-modal action-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handlecheckCloses}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {/* <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec'  style={{display:  rejectLog  ? 'none' : 'block' }}> */}
            <div className={`copy-sec-modal logout-sec-modal add-club-sec app-club-sec ${approveLog ? 'sectionhide' : ''}`} style={{ display: rejectLog ? 'none' : 'block' }}>
              <h2>This application requires an Action</h2>
              <div className='button-sec-app'>
                <button className="btn btn-login btn-submit bt-forms btn-appr" onClick={handleapprove}>Approve </button>
                <button className="btn btn-login btn-submit bt-forms btn-reject" onClick={handlereject}>Reject </button>
              </div>
            </div>

            <div className='reject-sec logout-sec-modal' style={{ display: rejectLog ? 'block' : 'none' }}>
              <h2 style={{ marginBottom: '20px' }}>Reason for Rejection</h2>
              <textarea className='new-textara-inpt' type="text" id="fname" placeholder='' rows="4" cols="50" name="reject" onChange={handleReasonChange} value={reason} />
              <div className='button-sec-app'>
                <button className="btn btn-login btn-submit bt-forms" onClick={handlesubmit} type="button">
                  {
                    submitting ?
                      <>
                        Submit <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </>
                      :
                      <>
                        Submit
                      </>
                  }
                </button>
              </div>
              {
                submitSuccess ?
                  <div className="success-msg success-login success-new-msg">
                    <p className="success-msg success-login" >{submitSuccess}</p>
                  </div>
                  : null
              }
              {
                submitErr ?
                  <div className="error-msg error-login" >
                    <p className="error-msg error-login">{submitErr}</p>
                  </div>
                  : null
              }
            </div>

            <div className='reject-sec logout-sec-modal' style={{ display: approveLog ? 'block' : 'none' }}>
              <h2 style={{ marginBottom: '20px' }}>Your Feedback</h2>
              <textarea className='new-textara-inpt' type="text" id="fname" placeholder='' rows="4" cols="50" name="reject" onChange={handleReasonChange} value={reason} />
              <div className='button-sec-app'>
                <button className="btn btn-login btn-submit bt-forms" onClick={handlesubmit} type="button">
                  {
                    submitting ?
                      <>
                        Submit <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      </>
                      :
                      <>
                        Submit
                      </>
                  }
                </button>
              </div>
              {
                submitSuccess ?
                  <div className="success-msg success-login success-new-msg">
                    <p className="success-msg success-login" >{submitSuccess}</p>
                  </div>
                  : null
              }
              {
                submitErr ?
                  <div className="error-msg error-login" >
                    <p className="error-msg error-login">{submitErr}</p>
                  </div>
                  : null
              }
            </div>



          </Typography>
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={handleFormsClose}
        aria-labelledby="customized-dialog-title"
        open={openformsLog} className="route-view copy-view logout-view login-modal app-modal action-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleFormsClose}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {/* <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec'  style={{display:  rejectLog  ? 'none' : 'block' }}> */}
            <div className={`copy-sec-modal logout-sec-modal add-club-sec app-club-sec `}  >
              {formsdata != null ?
                <>
                  <h2>{formsdata.pending_parent_form} forms pending, do you want to still proceed?</h2>
                </>

                :
                ''}

              <div className='button-sec-app'>
                {formsdata != null ?
                  <>
                    <button className="btn btn-login btn-submit bt-forms btn-appr" onClick={() => handleFormStatus(formsdata)}>Yes </button>
                    <button className="btn btn-login btn-submit bt-forms btn-reject" onClick={handleFormsClose}>No </button>

                  </>

                  :
                  ''}

              </div>
            </div>







          </Typography>
        </DialogContent>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={isUploadedClose}
        aria-labelledby="customized-dialog-title"
        open={openIsUploaded} className="route-view copy-view logout-view  club-modal clear-form new-form-modal under-main">
        <BootstrapDialogTitle className="close-routeview fill-cls-rut" id="customized-dialog-title" onClose={isUploadedClose}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {/* <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec'  style={{display:  rejectLog  ? 'none' : 'block' }}> */}
            <div className={`copy-sec-modal logout-sec-modal add-club-sec app-club-sec `}  >
              <div className='check-sec modal-check-sec'>
                <div className='row'>
                  <div className='col-md-12' style={{ marginTop: '12px', marginBottom: '8px' }}>
                    {
                      formsdata != null ?
                        <>
                        {formsdata.is_uploaded==0  ? 
                        <>
                         {
                            formsdata.pending_parent_form != 0 ?
                              <p className="para-fill">This application has pending forms, do you want to mark it as completed?</p>
                              :
                              <p className="para-fill">You are marking this application as completed</p>
                          }
                        </>
                        :  <>
                           <p className="para-fill">You are unchecking the completed upload form status</p>
                        </>}
                         
                        </>
                        : null
                    }
                  </div>
                  <div className='col-md-12'>
                    <div className='login-submit login-submitss modal-submit login-clear understnd-sec' style={{ marginTop: '0px', marginBottom: '10px' }}>
                      <FormGroup className='radio-sec'>
                        <FormControlLabel label="I understand" control={<Checkbox />}
                          checked={checkUnderstand} onChange={handleChangeUnderstand} />
                      </FormGroup>
                      <button className='btn btn-login btn-submit btn-pro btn-prcd btn-procds' style={{ marginBottom: '5px', marginTop: '0px' }}
                        disabled={checkUnderstand == false ? 'disabled' : false} onClick={handleIsUploadConfirm}>
                        {
                          isUploadedProcessing ?
                            <>
                              PROCEED <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </>
                            :
                            <>
                              PROCEED
                            </>
                        }
                      </button>
                    </div>
                  </div>
                  <div className='col-md-12' style={{ marginBottom: '10px' }}>
                    {
                      isUploadedSuccess ?
                        <div className="success-msg success-login success-new-msg">
                          <p className="success-msg success-login" >{isUploadedSuccess}</p>
                        </div>
                        : null
                    }
                    {
                      isUploadedErr ?
                        <div className="error-msg error-login" >
                          <p className="error-msg error-login">{isUploadedErr}</p>
                        </div>
                        : null
                    }
                  </div>
                </div>
              </div>
            </div>
          </Typography>
        </DialogContent>
      </BootstrapDialog>
      <BootstrapDialog
        onClose={handleDeleleClose}
        aria-labelledby="customized-dialog-title"
        open={openLogDelele} className="route-view copy-view logout-view login-modal app-modal action-modl">
        <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleDeleleClose}>
          {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {/* <div className='copy-sec-modal logout-sec-modal add-club-sec app-club-sec'  style={{display:  rejectLog  ? 'none' : 'block' }}> */}
            <div className={`copy-sec-modal logout-sec-modal add-club-sec app-club-sec `}  >

              <h2>Do you want to delete this Physician Form?</h2>


              <div className='button-sec-app'>
                {alldelete != null ?
                  <>
                    <button className="btn btn-login btn-submit bt-forms btn-appr" onClick={() => handlePhycianDelte()}> {
                      uploading ?
                        <>
                          Yes <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </>
                        :
                        <>
                          Yes
                        </>
                    } </button>
                    <button className="btn btn-login btn-submit bt-forms btn-reject" onClick={handleDeleleClose}>No </button>

                  </>

                  :
                  ''}

              </div>
              {
                uploadSuccess ?
                  <div className="success-msg success-login success-new-msg">
                    <p className="success-msg success-login" >{uploadSuccess}</p>
                  </div>
                  : null
              }
              {
                uploadErr ?
                  <div className="error-msg error-login" >
                    <p className="error-msg error-login">{uploadErr}</p>
                  </div>
                  : null
              }
            </div>







          </Typography>
        </DialogContent>
      </BootstrapDialog>

      {/* modal section end */}



    </>
  )
}
export default Application;
